((GlobalNavMobile, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.globalNavMobileMenuToggleButton = $('.global-nav--mobile--toggle-menu');
    $dom.globalNavMobileMenuAccordion = $('#global-nav--mobile .has-dropdown > a');
    $dom.globalNavMobile = $('#global-nav--mobile');
    $dom.promoBar = $('#shopify-section-promos');
  };

  const bindUIActions = () => {
    /*
      MAIN MENU - OPEN/CLOSE MENU
    */
    $dom.globalNavMobileMenuToggleButton.on('click', function(event) {
      toggleMobileMenu();
    });


    /*
      MAIN MENU - ACCORDION MENUS
    */
    $dom.globalNavMobileMenuAccordion.on('click', function(event) {
      event.preventDefault();
      $(this).parent().toggleClass('js-is-active-menu');
      $(this).parent().siblings().removeClass('js-is-active-menu');
    });

    const toggleMobileMenu = () => {

      // get height of header + promo bar
      const headerNav = $('#shopify-section-header');
      const headerHeight = headerNav.length > 0 ? headerNav.innerHeight() : 0;

      // get height of promo bar (no sticky logic because menu currently forces window to scroll to top)
      let promoHeight = $dom.promoBar.length > 0 ? 44 : 0;

      // set the mobile menu positioning
      $dom.globalNavMobile.css('top', `${promoHeight + headerHeight}px`);

      // apply open class for transition, scroll lock the body
      $('body').toggleClass('js-global-nav--mobile--open');
      $('body, html').toggleClass('scroll-lock');
    }

    /*
      SEARCH - MOBILE - NAV
    */
    $('.search-click-mobile').on(`click`, function(event) {
      console.log(`---search-click-mobile`);
      if (!$(`.global-nav--mobile--top .search .search-bar`).hasClass(`js-is-focused`)) {
        $(`.global-nav--mobile--top .search .search-bar`).addClass(`js-is-focused`);
      }
      if (!$(`body`).hasClass(`js-global-nav--mobile--open`)) {
        toggleMobileMenu();
      }
      $(`.global-nav--mobile--top .search .search-bar input`).focus();
    });

    /*
      SEARCH - MOBILE - INPUT/TEXT TRANISTION
    */
    $('.global-nav--mobile--top .search .search-bar').on('click', function(event) {
      if ( $(this).hasClass('js-is-focused') == false ) {
        $(this).addClass('js-is-focused');
      }
    });

    $('#global-nav--mobile .search .input-wrapper input').on('blur', function(event) {
      $('.global-nav--mobile--top .search .search-bar').delay(800).removeClass('js-is-focused');
    });


    /*
      SEARCH - DESKTOP - SHOW
    */
    $('.search-click').on('click', function(event) {
      $('.search-wrapper').slideDown(600, function () {
        $('.search-wrapper input').focus();
      });
    });


    /*
      SEARCH - DESKTOP - HIDE
    */
    $('.search-wrapper span.input-group-btn button').on('click', function(event) {
      $('.search-wrapper').slideUp(600);
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  GlobalNavMobile.init = init;

})(window.GlobalNavMobile = window.GlobalNavMobile || {}, jQuery);
